import React, { useState } from "react";
import { RCCButton, RCCCheckBox, RCCGrid, RCCIcon, RCCTooltip } from "react-common-components";
import { useAuth } from "src/context/Auth/context";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import LovUsers from "../Lov/Users";
import LovUsersGroups from "../Lov/UsersGroups";
import Title from "../Title";
import { IComponentRACI, IParticipant } from "./interface";

const RACI: React.FC<IComponentRACI> = ({
	accountable,
	control,
	error,
	participants,
	register,
	responsible,
	clearErrors,
	unregister,
	disabled,
	noCheckbox
}) => {
	const { translate } = useTranslation();
	const { user } = useAuth();
	const convertDefaultValueToParticipantState = (defaultValue: Array<any>): IParticipant[] => defaultValue.map((dfvalue) => ({
		id: dfvalue[participants.nameOfID],
		efa005Id: dfvalue[participants.nameOfSelectUser],
		efa004Id: dfvalue[participants.nameOfSelectGroup],
		notifyParticipant: participants.nameOfCheckbox ? dfvalue[participants.nameOfCheckbox] : undefined,
		type: dfvalue[participants.nameOfType],
		efa004Descricao: participants.nameOfSelectGroupDescription ? dfvalue[participants.nameOfSelectGroupDescription] : undefined,
		efa005Nome: participants.nameOfSelectUserDescription ? dfvalue[participants.nameOfSelectUserDescription] : undefined
	}));
	const [participantsState, setParticipantsState] = useState<IParticipant[]>(participants.defaultValue ? convertDefaultValueToParticipantState(participants.defaultValue) : []);
    
	const addNewConsulted = (type: "User" | "Group") => {
    	if(type === "User"){
    		setParticipantsState((prevState) => [...prevState, {efa005Id: 0, type: "C"}]);
    		return;
    	}
    	setParticipantsState((prevState) => [...prevState, {efa004Id: 0, type: "C"}]);
	};
	const addNewInformed = (type: "User" | "Group") => {
    	if(type === "User"){
    		setParticipantsState((prevState) => [...prevState, {efa005Id: 0, type: "I"}]);
    		return;
    	}
    	setParticipantsState((prevState) => [...prevState, {efa004Id: 0, type: "I"}]);
	};
	const removeParticipant = (index: number) => {
    	unregister(`${participants.nameOfObject}`);
		clearErrors(participants.nameOfObject);
    	setParticipantsState((prevState) => prevState.filter((_, idx) => idx !== index));
	};
	const onChangeSelectConsulted = (option: { value: string, label: string}, index: number, type: "User" | "Group") => {
		clearErrors(participants.nameOfObject);
		if(type === "User"){
			setParticipantsState((prevState) => {
				const updateState = [...prevState];
				updateState[index].efa005Id = Number(option.value);
				updateState[index].efa005Nome = option.label;
				return updateState;
			});
			return;
		}
		setParticipantsState((prevState) => {
			const updateState = [...prevState];
			updateState[index].efa004Id = Number(option.value);
			updateState[index].efa004Descricao = option.label;
			return updateState;
		});
	};
	const onChangeSelectInformed = (option: { value: string, label: string}, index: number, type: "User" | "Group") => {
		clearErrors(participants.nameOfObject);
		if(type === "User"){
			setParticipantsState((prevState) => {
				const updateState = [...prevState];
				updateState[index].efa005Id = Number(option.value);
				updateState[index].efa005Nome = option.label;
				return updateState;
			});
			return;
		}
		setParticipantsState((prevState) => {
			const updateState = [...prevState];
			updateState[index].efa004Id = Number(option.value);
			updateState[index].efa004Descricao = option.label;
			return updateState;
		});
	};
	const onChangeCheckboxParticipant = (value: boolean, index: number) => {
		setParticipantsState((prevState) => {
			const updateState = [...prevState];
			updateState[index].notifyParticipant = value ? "S" : "N";
			return updateState;
		});
	};
	
	return (
		<RCCGrid
			container
			item
			direction="column"
			alignItems="center"
			justifyContent="center"
		>
			{/* Responsible */}
			<RCCGrid
				container
				item
				xs={12}
				md={10}
				alignItems="flex-end"
			>
				<RCCGrid
					container
					item
					xs={12}
					sm={!noCheckbox ? 6 : 11}
				>
					<LovUsers 
						control={control}
						name={responsible.nameOfSelect}
						label={translate("Responsável")}
						defaultValue={responsible.defaultValue?.select ? responsible.defaultValue?.select : {
							value: user.efa005Id ,
							label:  user.efa005Nome 
						}}
						error={error[responsible.nameOfSelect]}
						required
						disabled={disabled}
					/>
				</RCCGrid>
				{
					!noCheckbox && 
					<RCCGrid
						container
						item
						xs={12}
						sm={5}
					>
						<RCCCheckBox 
							name={responsible.nameOfCheckbox ? responsible.nameOfCheckbox : ""}
							defaultChecked={responsible.defaultValue?.checkbox !== "N"}
							label={translate("Acompanhar andamento")}
							labelPosition="end"
							register={register}
							styleInline={{checkbox: "padding-left: 5%;"}}
							error={error[responsible.nameOfCheckbox ? responsible.nameOfCheckbox : ""]}
							disabled={disabled}
						/>
					</RCCGrid>
				}
				
			</RCCGrid>
			{/* Accountable */}
			<RCCGrid
				container
				item
				xs={12}
				md={10}
				alignItems="flex-end"
			>
				<RCCGrid
					container
					item
					xs={12}
					sm={!noCheckbox ? 6 : 11}
				>
					<LovUsers 
						control={control}
						name={accountable.nameOfSelect}
						label={translate("Autoridade")}
						defaultValue={accountable.defaultValue?.select ? accountable.defaultValue?.select : {
							value: user.efa005Id,
							label: user.efa005Nome 
						}}
						error={error[accountable.nameOfSelect]}
						required
						disabled={disabled}
					/>
				</RCCGrid>
				{
					!noCheckbox && 
					<RCCGrid
						container
						item
						xs={12}
						sm={5}
					>
						<RCCCheckBox 
							name={accountable.nameOfCheckbox ? accountable.nameOfCheckbox : ""}
							defaultChecked={accountable.defaultValue?.checkbox !== "N"}
							label={translate("Acompanhar andamento")}
							labelPosition="end"
							register={register}
							error={error[accountable.nameOfCheckbox ? accountable.nameOfCheckbox : ""]}
							styleInline={{checkbox: "padding-left: 5%;"}}
							disabled={disabled}
						/>
					</RCCGrid>
				}
				
			</RCCGrid>
			<RCCGrid
				container
				item
				alignItems="center"
				justifyContent="flex-end"
				style={{minHeight: "24px"}}
			>
				{error[participants.nameOfObject] && (
					<>
						<RCCIcon name="infoCircle" size={18} color="var(--red)"/>
						<Title color="red" size="xs">{error[participants.nameOfObject].message}</Title>
					</>
				)}
			</RCCGrid>
			<hr />
			{/* Consulted */}
			<RCCGrid
				container
				item
				direction="column"
			>
				<Title 
					color="purple"
					marginBottom={15}
				>
					{translate("Consultados")}
				</Title>
            
				<RCCGrid 
					container
					item
				>
					<RCCTooltip
						color="purple"
						text={translate("Adicionar usuário")}
					>
						<RCCButton
							color="purple"
							icon={{
								name: "plus"
							}}
							onClick={() => addNewConsulted("User")}
							disabled={disabled}
						>
							{translate("Usuário")}
						</RCCButton>
					</RCCTooltip>
					<RCCTooltip
						color="grey"
						text={translate("Adicionar grupo")}
					>
						<RCCButton
							color="grey"
							icon={{
								name: "plus"
							}}
							onClick={() => addNewConsulted("Group")}
							disabled={disabled}
						>
							{translate("Grupo")}
						</RCCButton>
					</RCCTooltip>
				</RCCGrid>
				<RCCGrid
					container
					item
					direction="column"
					alignItems="center"
					justifyContent="center"
				>
					{participantsState.filter((consult) => consult.efa005Id !== undefined && consult.efa005Id !== null && consult.type === "C").length > 0 && (
						<RCCGrid
							container
							item
							xs={12}
							md={10}
						>
							<Title color="purple"
								size="sm"
							>
								{translate("Usuários")}
							</Title>
							<hr />
						</RCCGrid>
					)}
					<RCCGrid
						container
						item
						xs={12}
						md={10}
					>
						{participantsState.map((consult, index) => consult.efa005Id !== undefined && consult.efa005Id !== null  && consult.type === "C" && (
							<RCCGrid
								key={v4()}
								container
								item
								alignItems="flex-end"
								justifyContent="space-between"
							>
								<input 
									name={`${participants.nameOfObject}[${index}].${participants.nameOfID}`} 
									type="text"
									value={consult.id || 0}
									{...register(`${participants.nameOfObject}[${index}].${participants.nameOfID}`)} 
									style={{ display: "none" }} 
									readOnly
								/>

								<input 
									name={`${participants.nameOfObject}[${index}].${participants.nameOfType}`} 
									type="text"
									value="C"
									{...register(`${participants.nameOfObject}[${index}].${participants.nameOfType}`)} 
									style={{ display: "none" }} 
									readOnly
								/>
							
								<RCCGrid
									container
									item
									xs={12}
									sm={!noCheckbox ? 6 : 11}
								>
									<LovUsers 
										control={control}
										label=""
										name={`${participants.nameOfObject}[${index}].${participants.nameOfSelectUser}`}
										defaultValue={consult.efa005Id && (consult.efa005Nome ? { value: String(consult.efa005Id), label: consult.efa005Nome } : consult.efa005Id.toString())}
										onChangeCapture={(option: { value: string; label: string; }) => onChangeSelectConsulted(option, index, "User")}
										error={error[`${participants.nameOfObject}`] && error[`${participants.nameOfObject}[${index}].${participants.nameOfSelectUser}`]}
										disabled={disabled}
										styleInline="height: 40px; min-height: 40px;"
									/>
								</RCCGrid>
							
								{
									!noCheckbox &&
									<RCCGrid
										container
										item
										xs={5}
									>
										<RCCCheckBox 
											name={`${participants.nameOfObject}[${index}].${participants.nameOfCheckbox}`}
											defaultChecked={consult.notifyParticipant !== "N"}
											label={translate("Acompanhar andamento")}
											labelPosition="end"
											register={register}
											onChangeCapture={(e: React.ChangeEvent<HTMLInputElement>) => onChangeCheckboxParticipant(e.target.checked, index)}
											error={error[`${participants.nameOfObject}`] && error[`${participants.nameOfObject}[${index}].${participants.nameOfCheckbox}`]}
											disabled={disabled}
										/>
									</RCCGrid>
								}
								
								<RCCTooltip
									color="red"
									text={translate("Remover")}
								>
									<RCCButton 
										color="red"
										icon={{
											name: "trash"
										}}
										onClick={() => removeParticipant(index)}
										disabled={disabled}
									/>
								</RCCTooltip>
							</RCCGrid>
						))}
					</RCCGrid>
					{participantsState.filter((consult) => consult.efa004Id !== undefined && consult.efa004Id !== null  && consult.type === "C").length > 0 && (
						<RCCGrid
							container
							item
							xs={12}
							md={10}
						>
							<Title color="purple"
								size="sm"
							>
								{translate("Grupos")}
							</Title>
							<hr />
						</RCCGrid>
					)}
					<RCCGrid
						container
						item
						xs={12}
						md={10}
					>
						{participantsState.map((consult, index) => consult.efa004Id !== undefined && consult.efa004Id !== null  && consult.type === "C" && (
							<RCCGrid
								key={v4()}
								container
								item
								alignItems="flex-end"
								justifyContent="space-between"
							>
								<input 
									name={`${participants.nameOfObject}[${index}].${participants.nameOfID}`} 
									type="text"
									value={consult.id || 0}
									{...register(`${participants.nameOfObject}[${index}].${participants.nameOfID}`)} 
									style={{ display: "none" }} 
									readOnly
								/>

								<input 
									name={`${participants.nameOfObject}[${index}].${participants.nameOfType}`} 
									type="text"
									value="C"
									{...register(`${participants.nameOfObject}[${index}].${participants.nameOfType}`)} 
									style={{ display: "none" }} 
									readOnly
								/>

								<RCCGrid
									container
									item
									xs={12}
									sm={!noCheckbox ? 6 : 11}
								>
									<LovUsersGroups 
										control={control}
										label=""
										name={`${participants.nameOfObject}[${index}].${participants.nameOfSelectGroup}`}
										defaultValue={consult.efa004Id && (consult.efa004Descricao ? { value: String(consult.efa004Id), label: consult.efa004Descricao } : consult.efa004Id?.toString())}
										onChangeCapture={(option: { value: string; label: string; }) => onChangeSelectConsulted(option, index, "Group")}
										error={error[`${participants.nameOfObject}`] && error[`${participants.nameOfObject}[${index}].${participants.nameOfSelectGroup}`]}
										disabled={disabled}
										styleInline="height: 40px; min-height: 40px;"
									/>
								</RCCGrid>
								{
									!noCheckbox &&
									<RCCGrid
										container
										item
										xs={5}
									>
										<RCCCheckBox 
											name={`${participants.nameOfObject}[${index}].${participants.nameOfCheckbox}`}
											defaultChecked={consult.notifyParticipant !== "N"}
											label={translate("Acompanhar andamento")}
											labelPosition="end"
											register={register}
											onChangeCapture={(e: React.ChangeEvent<HTMLInputElement>) => onChangeCheckboxParticipant(e.target.checked, index)}
											error={error[`${participants.nameOfObject}`] && error[`${participants.nameOfObject}[${index}].${participants.nameOfCheckbox}`]}
											disabled={disabled}
										/>
									</RCCGrid>
								}
								<RCCTooltip
									color="red"
									text={translate("Remover")}
								>
									<RCCButton 
										color="red"
										icon={{
											name: "trash"
										}}
										onClick={() => removeParticipant(index)}
										disabled={disabled}
									/>
								</RCCTooltip>
							</RCCGrid>
						))}
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
			<br />
			<hr />
			{/* Informed */}
			<RCCGrid
				container
				item
				direction="column"
			>
				<Title 
					color="purple"
					marginBottom={15}
				>
					{translate("Informados")}
				</Title>
            
				<RCCGrid 
					container
					item
				>
					<RCCTooltip
						color="purple"
						text={translate("Adicionar usuário")}
					>
						<RCCButton
							color="purple"
							icon={{
								name: "plus"
							}}
							onClick={() => addNewInformed("User")}
							disabled={disabled}
						>
							{translate("Usuário")}
						</RCCButton>
					</RCCTooltip>
					<RCCTooltip
						color="grey"
						text={translate("Adicionar grupo")}
					>
						<RCCButton
							color="grey"
							icon={{
								name: "plus"
							}}
							onClick={() => addNewInformed("Group")}
							disabled={disabled}
						>
							{translate("Grupo")}
						</RCCButton>
					</RCCTooltip>
				</RCCGrid>
				<RCCGrid
					container
					item
					direction="column"
					alignItems="center"
					justifyContent="center"
				>
					{participantsState.filter((inform) => inform.efa005Id !== undefined && inform.efa005Id !== null && inform.type === "I").length > 0 && (
						<RCCGrid
							container
							item
							xs={12}
							md={10}
						>
							<Title color="purple"
								size="sm"
							>
								{translate("Usuários")}
							</Title>
							<hr />
						</RCCGrid>
					)}
					<RCCGrid
						container
						item
						xs={12}
						md={10}
					>
						{participantsState.map((inform, index) => inform.efa005Id !== undefined && inform.efa005Id !== null  && inform.type === "I" && (
							<RCCGrid
								key={v4()}
								container
								item
								alignItems="flex-end"
								justifyContent="space-between"
							>
								<input 
									name={`${participants.nameOfObject}[${index}].${participants.nameOfID}`} 
									type="text"
									value={inform.id || 0}
									{...register(`${participants.nameOfObject}[${index}].${participants.nameOfID}`)} 
									style={{ display: "none" }} 
									readOnly
								/>

								<input 
									name={`${participants.nameOfObject}[${index}].${participants.nameOfType}`} 
									type="text"
									value="I"
									{...register(`${participants.nameOfObject}[${index}].${participants.nameOfType}`)} 
									style={{ display: "none" }} 
									readOnly
								/>

								<RCCGrid
									container
									item
									xs={12}
									sm={6}
								>
									<LovUsers 
										control={control}
										label=""
										name={`${participants.nameOfObject}[${index}].${participants.nameOfSelectUser}`}
										defaultValue={inform.efa005Id && (inform.efa005Nome ? { value: String(inform.efa005Id), label: inform.efa005Nome } : inform.efa005Id.toString())}
										onChangeCapture={(option: {value: string; label: string;}) => onChangeSelectInformed(option, index, "User")}
										error={error[`${participants.nameOfObject}`] && error[`${participants.nameOfObject}[${index}].${participants.nameOfSelectUser}`]}
										disabled={disabled}
										styleInline="height: 40px; min-height: 40px;"
									/>
								</RCCGrid>
								{
									!noCheckbox &&
									<RCCGrid
										container
										item
										xs={5}
									>
										<RCCCheckBox 
											name={`${participants.nameOfObject}[${index}].${participants.nameOfCheckbox}`}
											defaultChecked={inform.notifyParticipant !== "N"}
											label={translate("Acompanhar andamento")}
											labelPosition="end"
											register={register}
											onChangeCapture={(e: React.ChangeEvent<HTMLInputElement>) => onChangeCheckboxParticipant(e.target.checked, index)}
											error={error[`${participants.nameOfObject}`] && error[`${participants.nameOfObject}[${index}].${participants.nameOfCheckbox}`]}
											disabled={disabled}
										/>
									</RCCGrid>
								}
								<RCCTooltip
									color="red"
									text={translate("Remover")}
								>
									<RCCButton 
										color="red"
										icon={{
											name: "trash"
										}}
										onClick={() => removeParticipant(index)}
										disabled={disabled}
									/>
								</RCCTooltip>
							</RCCGrid>
						))}
					</RCCGrid>
					{participantsState.filter((inform) => inform.efa004Id !== undefined && inform.efa004Id !== null && inform.type === "I").length > 0 && (
						<RCCGrid
							container
							item
							xs={12}
							md={10}
						>
							<Title color="purple"
								size="sm"
							>
								{translate("Grupos")}
							</Title>
							<hr />
						</RCCGrid>
					)}
					<RCCGrid
						container
						item
						xs={12}
						md={10}
					>
						{participantsState.map((inform, index) => inform.efa004Id !== undefined && inform.efa004Id !== null && inform.type === "I" && (
							<RCCGrid
								key={v4()}
								container
								item
								alignItems="flex-end"
								justifyContent="space-between"
							>
								<input 
									name={`${participants.nameOfObject}[${index}].${participants.nameOfID}`} 
									type="text"
									value={inform.id || 0}
									{...register(`${participants.nameOfObject}[${index}].${participants.nameOfID}`)} 
									style={{ display: "none" }} 
									readOnly
								/>

								<input 
									name={`${participants.nameOfObject}[${index}].${participants.nameOfType}`} 
									type="text"
									value="I"
									{...register(`${participants.nameOfObject}[${index}].${participants.nameOfType}`)} 
									style={{ display: "none" }} 
									readOnly
								/>

								<RCCGrid
									container
									item
									xs={12}
									sm={6}
								>
									<LovUsersGroups 
										control={control}
										label=""
										name={`${participants.nameOfObject}[${index}].${participants.nameOfSelectGroup}`}
										defaultValue={inform.efa004Id && (inform.efa004Descricao ? { value: String(inform.efa004Id), label: inform.efa004Descricao } : inform.efa004Id.toString())}
										onChangeCapture={(option: {value: string; label: string;}) => onChangeSelectInformed(option, index, "Group")}
										error={error[`${participants.nameOfObject}`] && error[`${participants.nameOfObject}[${index}].${participants.nameOfSelectGroup}`]}
										disabled={disabled}
										styleInline="height: 40px; min-height: 40px;"
									/>
								</RCCGrid>
								{
									!noCheckbox &&
									<RCCGrid
										container
										item
										xs={5}
									>
										<RCCCheckBox 
											name={`${participants.nameOfObject}[${index}].${participants.nameOfCheckbox}`}
											defaultChecked={inform.notifyParticipant !== "N"}
											label={translate("Acompanhar andamento")}
											labelPosition="end"
											register={register}
											onChangeCapture={(e: React.ChangeEvent<HTMLInputElement>) => onChangeCheckboxParticipant(e.target.checked, index)}
											error={error[`${participants.nameOfObject}`] && error[`${participants.nameOfObject}[${index}].${participants.nameOfCheckbox}`]}
											disabled={disabled}
										/>
									</RCCGrid>
								}
								<RCCTooltip
									color="red"
									text={translate("Remover")}
								>
									<RCCButton 
										color="red"
										icon={{
											name: "trash"
										}}
										onClick={() => removeParticipant(index)}
										disabled={disabled}
									/>
								</RCCTooltip>
							</RCCGrid>
						))}
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
		</RCCGrid>
	);
};

export default RACI;
